var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanySolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9085 9.55329C16.3377 9.26219 15.662 9.26218 15.0912 9.55329L7.75785 13.2933C7.08812 13.6349 6.6665 14.3232 6.6665 15.075V23.9999C6.6665 26.2091 8.45736 27.9999 10.6665 27.9999H11.8138C12.6529 27.9999 13.3332 27.3197 13.3332 26.4806V22.6666C13.3332 21.1938 14.5271 19.9999 15.9998 19.9999C17.4726 19.9999 18.6665 21.1938 18.6665 22.6666V26.4806C18.6665 27.3197 19.3468 27.9999 20.1859 27.9999H21.3332C23.5423 27.9999 25.3332 26.2091 25.3332 23.9999V15.075C25.3332 14.3232 24.9116 13.6349 24.2418 13.2933L16.9085 9.55329Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.14057 11.2629C4.46989 11.9215 5.27078 12.1885 5.92942 11.8592L15.9998 6.824L26.0702 11.8592C26.7288 12.1885 27.5297 11.9215 27.859 11.2629C28.1884 10.6043 27.9214 9.80337 27.2628 9.47405L16.5961 4.14072C16.2207 3.95303 15.7789 3.95303 15.4035 4.14072L4.73685 9.47405C4.07821 9.80337 3.81125 10.6043 4.14057 11.2629Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanySolid);
export default __webpack_public_path__ + "static/media/company-solid.6f5edd87.svg";
export { ForwardRef as ReactComponent };